
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/what-we-buy/sell-diamonds-nyc/[uid]",
      function () {
        return require("private-next-pages/what-we-buy/sell-diamonds-nyc/[uid]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/what-we-buy/sell-diamonds-nyc/[uid]"])
      });
    }
  